module.exports = __webpack_public_path__ + "fonts/MyriadPro-Cond.0faa4e4.woff2";